import { Component, OnInit, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ProductService } from '../../../core/services/product.service';
import { AuthService } from '../../../core/services/auth.service';
import { Category } from '../../../core/models/category/category';
import { CartService } from '../../../core/services/cart/cart.service';

@Component({
  selector: 'app-home-header',
  imports: [RouterModule, CommonModule],
  templateUrl: './home-header.component.html',
  styleUrl: './home-header.component.scss',
})
export class HomeHeader implements OnInit {
  private readonly productService = inject(ProductService);
  private readonly authService = inject(AuthService);
  private readonly cartService = inject(CartService);
  categories = signal<Category[]>([]);
  isMobileMenuOpen = signal<boolean>(false);
  expandedCategoryId = signal<number | null>(null);

  cartCount$ = this.cartService.cartCount$;

  constructor(private router: Router) {}

  toggleMobileMenu(): void {
    this.isMobileMenuOpen.update(val => !val);
    if (!this.isMobileMenuOpen()) {
      this.expandedCategoryId.set(null);
    }
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen.set(false);
    this.expandedCategoryId.set(null);
  }

  toggleMobileCategory(categoryId: number, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.expandedCategoryId() === categoryId) {
      this.expandedCategoryId.set(null);
    } else {
      this.expandedCategoryId.set(categoryId);
    }
  }

  ngOnInit(): void {
    this.productService.getCategoriesWithSubcategories().subscribe({
      next: (data) => {
        this.categories.set(data);
      },
      error: (err) => {
        console.error('Error loading categories', err);
      }
    });
  }

  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  get userName(): string {
    const user: any = this.authService.getUser();
    return user?.name || user?.userName || 'User';
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/']);
  }

  get isOnFindEvents(): boolean {
    return this.router.url.includes('/find-events');
  }
}
